import { normalize, schema } from 'normalizr'
import { IAssistanceCategoryObject, IAssistanceObject } from '../types'
import Paths from '../utils/paths'
import { serverApi } from '../utils/request'

const assistanceResponse = [
  {
    id: '1',
    name: 'Folding Wheelchair',
    category: 'Wheelchair',
    active: true
  },
  {
    id: '2',
    name: 'Non Folding Wheelchair',
    category: 'Wheelchair',
    active: true
  },
  {
    id: '3',
    name: 'Scooter',
    category: 'Wheelchair',
    active: false
  },
  {
    id: '4',
    name: 'Powerchair',
    category: 'Wheelchair',
    active: false
  },
  {
    id: '5',
    name: 'Folding Walker',
    category: 'Walker',
    active: false
  },
  {
    id: '6',
    name: 'Non Folding Walker',
    category: 'Walker',
    active: false
  }
]

const assistanceCategoriesResponse = [
  {
    id: '1',
    name: 'Hearing'
  },
  {
    id: '2',
    name: 'Mobility'
  },
  {
    id: '3',
    name: 'Speaking'
  },
  {
    id: '4',
    name: 'Vision'
  }
]

class AssistanceService {
  private schemaAssistanceCategoriesOnly = new schema.Entity('assistanceCategories')
  private schemaAssistanceCategoriesResponse = [this.schemaAssistanceCategoriesOnly]

  private schemaAssistance = new schema.Entity('assistances')
  private schemaAssistanceResponse = [this.schemaAssistance]

  private schemaAssistanceOptions = new schema.Entity('assistanceOptions')
  private schemaAssistanceCategories = new schema.Entity('assistanceCategories', {
    assistances: [this.schemaAssistanceOptions]
  })
  private schemaAssistanceCategoriesWithOptionsResponse = [this.schemaAssistanceCategories]

  public getAssistanceCategoriesWithOptions() {
    return serverApi.get(Paths.assistanceCategory.getAllWithAssistances).then(({ data }) => {
      const normalized = normalize(data, this.schemaAssistanceCategoriesWithOptionsResponse)
      if (!normalized.entities) {
        return { assistanceOptions: {}, assistanceCategories: {} }
      }
      return normalized.entities
    })
  }

  public getAssistances() {
    return serverApi.get(Paths.assistance.getAll).then(({ data }) => {
      const normalized = normalize(data, this.schemaAssistanceResponse)
      if (!normalized.entities || !normalized.entities.assistances) {
        return {}
      }
      return normalized.entities.assistances
    })
  }

  public getAssistanceCategories() {
    return serverApi.get(Paths.assistanceCategory.getAll).then(({ data }) => {
      const normalized = normalize(data, this.schemaAssistanceCategoriesResponse)
      if (!normalized.entities || !normalized.entities.assistanceCategories) {
        return {}
      }
      return normalized.entities.assistanceCategories
    })
  }

  // TODO: Implement service
  public fetchAssistances() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(assistanceResponse)
      }, 1000)
    })
  }

  // TODO: Implement service
  public searchAssistances(query: string): any {
    return new Promise((resolve, reject) => {
      const str = new RegExp(query, 'i')
      const filtered = assistanceResponse.filter((assistance: any) => {
        if (assistance.name.match(str)) {
          return assistance
        }
      })
      resolve(filtered)
    })
  }

  // TODO: Implement service
  public removeCategory(id: string) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(id)
      }, 1000)
    })
  }

  // TODO: Implement service
  public createCategory(category: IAssistanceCategoryObject) {
    const id = new Date().getTime().toString()
    const obj = { ...category, id }
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(obj)
      }, 1000)
    })
  }

  public createAssistance(assistance: IAssistanceObject) {
    return serverApi.post(Paths.assistance.create, assistance).then(({ data }) => {
      return data
    })
  }

  public updateAssistance(assistance: IAssistanceObject) {
    return serverApi.put(Paths.assistance.create, assistance).then(({ data }) => {
      return data
    })
  }

  public removeAssistance(assistance: IAssistanceObject) {
    return serverApi.delete(Paths.assistance.remove + '/' + assistance.id).then(({ data }) => {
      return data
    })
  }
}

const assistanceService = new AssistanceService()

export { assistanceService }



// WEBPACK FOOTER //
// ./src/services/Assistance.ts